import { render, staticRenderFns } from "./ExtensionsDashboard.vue?vue&type=template&id=1184193a&scoped=true"
import script from "./ExtensionsDashboard.vue?vue&type=script&lang=js"
export * from "./ExtensionsDashboard.vue?vue&type=script&lang=js"
import style0 from "./ExtensionsDashboard.vue?vue&type=style&index=0&id=1184193a&prod&lang=css"
import style1 from "./ExtensionsDashboard.vue?vue&type=style&index=1&id=1184193a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1184193a",
  null
  
)

export default component.exports